@if (state === 'paused') {
  <ion-row class="toast-row-pause ion-align-items-center" @state (click)="dismissToastr()">
    <ion-col size="2" class="toast-col">
      <img src="../../../assets/images/pause-toast.png" alt="" class="toast-img" />
    </ion-col>
    <ion-col size="10">
      <p class="toast-msg" [innerHTML]="data.message | safeHtml"></p>
    </ion-col>
    <div class="progress">
      <div class="progress-value"></div>
    </div>
  </ion-row>
}
@if (state === 'stop') {
  <ion-row class="toast-row-stop ion-align-items-center" @state (click)="dismissToastr()">
    <ion-col size="2" class="toast-col">
      <img src="../../../assets/icon/stop-icon.png" alt="" class="toast-img" />
    </ion-col>
    <ion-col size="10">
      <p class="toast-msg" [innerHTML]="data.message | safeHtml"></p>
    </ion-col>
    <div class="progress">
      <div class="progress-value"></div>
    </div>
  </ion-row>
}
@if (state === 'success') {
  <ion-row class="toast-row-success ion-align-items-center" @state (click)="dismissToastr()">
    <ion-col size="2" class="toast-col">
      <img src="../../../assets/icon/{{icon}}" alt="" class="toast-img" />
    </ion-col>
    <ion-col size="10">
      <!-- <p class="toast-msg">{{ message }}</p> -->
      <p class="toast-msg" [innerHTML]="message | safeHtml"></p>
      @if (subMessage) {
        <p class="toast-msg-desc" [innerHTML]="subMessage | safeHtml"></p>
      }
    </ion-col>
    <div class="progress">
      <div class="progress-value"></div>
    </div>
  </ion-row>
}
@if (state === 'successwithdescription') {
  <ion-row class="toast-row-success ion-align-items-center" @state
    (click)="dismissToastr()">
    <ion-col size="2" class="toast-col">
      <img src="../../../assets/icon/tick circle success.png" alt="" class="toast-img" />
    </ion-col>
    <ion-col size="10">
      <p class="toast-msg">{{ message }}</p>
      <p class="toast-msg-desc">{{ description }}</p>
    </ion-col>
    <div class="progress">
      <div class="progress-value"></div>
    </div>
  </ion-row>
}
@if (state === 'fail') {
  <ion-row class="toast-row-fail ion-align-items-center" @state (click)="dismissToastr()">
    <ion-col size="2" class="toast-col">
      <img src="../../../assets/icon/tick circle error.svg" alt="" class="toast-img" />
    </ion-col>
    <ion-col size="10">
      <p class="toast-msg">{{ message }}</p>
    </ion-col>
    <div class="progress">
      <div class="progress-value"></div>
    </div>
  </ion-row>
}
@if (state === 'error') {
  <ion-row class="toast-row-fail ion-align-items-center" @state (click)="dismissToastr()">
    <ion-col size="2" class="toast-col">
      <img src="../../../assets/icon/{{icon}}" alt="" class="toast-img" />
    </ion-col>
    <ion-col size="10">
      <!-- <p class="toast-msg">{{ message }}</p> -->
      <p class="toast-msg" [innerHTML]="message | safeHtml"></p>
      @if (subMessage) {
        <p class="toast-msg-desc" [innerHTML]="subMessage | safeHtml"></p>
      }
    </ion-col>
    <div class="progress">
      <div class="progress-value"></div>
    </div>
  </ion-row>
}
<!-- <ion-row class="toast-row-stop ion-align-items-center" *ngIf="state === 'error'" (click)="dismissToastr()">
<ion-col size="2" class="toast-col">
  <img src="../../../assets/icon/stop-icon.png" alt="" class="toast-img" />
</ion-col>
<ion-col size="10">
  <p class="toast-msg-error" [innerHTML]="data.message | safeHtml"></p>
</ion-col>
</ion-row> -->
@if (state === 'info') {
  <ion-row class="toast-row-info ion-align-items-center" @state (click)="dismissToastr()">
    <ion-col size="2" class="toast-col">
      <img src="../../../assets/icon/{{icon}}" alt="" class="toast-img" />
    </ion-col>
    <ion-col size="10">
      <!--  <p class="toast-msg">{{ message }}</p> -->
      <p class="toast-msg" [innerHTML]="message | safeHtml"></p>
    </ion-col>
    <div class="progress">
      <div class="progress-value"></div>
    </div>
  </ion-row>
}
@if (state === 'warning') {
  <ion-row class="toast-row-pause ion-align-items-center" @state (click)="dismissToastr()">
    <ion-col size="2" class="toast-col">
      <img src="../../../assets/icon/{{icon}}" alt="" class="toast-img" />
    </ion-col>
    <ion-col size="10">
      <!--  <p class="toast-msg">{{ message }}</p> -->
      <p class="toast-msg" [innerHTML]="message | safeHtml"></p>
    </ion-col>
    <div class="progress">
      <div class="progress-value"></div>
    </div>
  </ion-row>
}